import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@medprompt/shared';
import './LoginView.css';

const CodeVerifyController = () => {
  const [verificationCode, setVerificationCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const { verify2FA } = useAuth();
  const email = location.state?.email;

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!verificationCode || verificationCode.length !== 6 || !/^\d+$/.test(verificationCode)) {
      setError('Please enter a valid 6-digit verification code');
      return;
    }
    
    try {
      setLoading(true);
      setError('');
      
      await verify2FA(email, verificationCode);
      
      // Improved navigation logic to handle different state formats
      let targetPath = '/';
      if (location.state?.from) {
        if (typeof location.state.from === 'string') {
          targetPath = location.state.from;
        } else if (location.state.from.pathname) {
          targetPath = location.state.from.pathname;
        }
      }
      
      console.log('2FA successful, navigating to:', targetPath);
      navigate(targetPath, { replace: true });
    } catch (error) {
      console.error('Verification failed:', error);
      setError('Incorrect code');
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => {
    navigate('/login');
  };

  // Validate if the input is a 6-digit string
  const handleCodeChange = (e) => {
    const value = e.target.value;
    // Only allow digits and max length of 6
    if (value === '' || (/^\d+$/.test(value) && value.length <= 6)) {
      setVerificationCode(value);
    }
  };

  return (
    <div className="login-container">
      <div className="login-form-container">
        <div className="login-header">
          <h1>Verification Required</h1>
          <p>Enter the 6-digit code sent to your email</p>
        </div>
        
        {error && <div className="login-error">{error}</div>}
        
        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="verificationCode">Verification Code</label>
            <input
              type="text"
              id="verificationCode"
              value={verificationCode}
              onChange={handleCodeChange}
              placeholder="Enter 6-digit code"
              disabled={loading}
              maxLength={6}
              required
            />
          </div>
          
          <button type="submit" className="login-button" disabled={loading || verificationCode.length !== 6 || !/^\d+$/.test(verificationCode)}>
            {loading ? 'Verifying...' : 'Verify'}
          </button>

          <button type="button" className="back-button" onClick={handleBack} disabled={loading}>
            Back to Login
          </button>
        </form>
      </div>
    </div>
  );
};

export default CodeVerifyController;